import { ApolloClient, NormalizedCacheObject } from '@apollo/client';

import { graphql } from '@eluve/graphql.tada';
import { Logger } from '@eluve/logger-main';
import { getMetadataFromFileName } from '@eluve/utils';

import { MarkClientAudioCompletedAtEvent, TaskHandler } from '../types';

const updateClientAudioCompletedAtMutation = graphql(`
  mutation updateClientAudioCompletedAt(
    $tenantId: uuid!
    $appointmentId: uuid!
    $fileId: uuid!
    $clientCompletedAt: timestamptz!
  ) {
    updateAppointmentFilesByPk(
      pkColumns: {
        tenantId: $tenantId
        appointmentId: $appointmentId
        fileId: $fileId
      }
      _set: { clientCompletedAt: $clientCompletedAt }
    ) {
      __typename
      appointmentId
      fileId
      clientCompletedAt
    }
  }
`);

export const markClientAudioCompletedAtHandler = ({
  apolloClient,
}: {
  apolloClient: ApolloClient<NormalizedCacheObject>;
  logger: Logger;
}): TaskHandler<MarkClientAudioCompletedAtEvent> => {
  return async (
    { appointmentId, fileId, clientCompletedAt },
    { tenantId, userId },
  ) => {
    const { databaseFileId } = getMetadataFromFileName({
      userId,
      fileName: fileId,
    });

    const result = await apolloClient.mutate({
      mutation: updateClientAudioCompletedAtMutation,
      variables: {
        tenantId,
        appointmentId,
        fileId: databaseFileId,
        clientCompletedAt,
      },
    });

    if (!result.data?.updateAppointmentFilesByPk) {
      throw new Error('Failed to mark client audio as completed');
    }
  };
};
